var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs-list"},[_c('li',{staticClass:"breadcrumbs-list__item return"},[_c('router-link',{attrs:{"to":_vm.parentRoute}},[_c('i',{staticClass:"icon-return"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }